/** @jsx jsx */
import { Alert, Button, Intent, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import AppToaster from '../../../AppToaster';
import {
  EmployeeDetailPageFragment,
  useDeleteEmployeeMutation,
  useForceDeleteEmployeeMutation,
  useRestoreEmployeeMutation,
} from '../../../generated/graphql';

type EmployeeDetailMenuProps = {
  employee: EmployeeDetailPageFragment;
  onEdit: () => void;
};

const EmployeeDetailMenu = ({ employee, onEdit }: EmployeeDetailMenuProps) => {
  const { user, id } = employee;
  const options = {
    variables: {
      id,
    },
  };
  const [isForceDeleteAlertOpen, setIsForceDeleteAlertOpen] = useState(false);

  const [deleteEmployee, { loading: deleting }] = useDeleteEmployeeMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${user.display_name}  wurde in den Papierkorb gelegt`),
  });
  const [restoreEmployee, { loading: restoring }] = useRestoreEmployeeMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${user.display_name}  wurde wiederhergestellt`),
  });
  const [forceDeleteEmployee, { loading: forceDeleting }] = useForceDeleteEmployeeMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${user.display_name}  wurde endgültig entfernt`),
  });

  if (!!employee.deleted_at) {
    return (
      <Fragment>
        <Alert
          isOpen={isForceDeleteAlertOpen}
          cancelButtonText="Abbrechen"
          confirmButtonText="Entfernen"
          icon={IconNames.DELETE}
          intent={Intent.DANGER}
          onClose={() => setIsForceDeleteAlertOpen(false)}
          onConfirm={forceDeleteEmployee as any}
        >
          <p>Soll dieser Mitarbeiter wirklich undwiderruflich entfernt werden?</p>
        </Alert>
        <Button
          text="Wiederherstellen"
          icon={IconNames.OFFLINE}
          css={styles.headerButton}
          onClick={restoreEmployee as any}
          loading={restoring}
        />
        <Popover
          position={Position.BOTTOM}
          content={
            <Menu>
              <MenuItem text="Bearbeiten" icon={IconNames.EDIT} onClick={onEdit} />
              <MenuItem
                text="Entfernen"
                icon={IconNames.DELETE}
                intent={Intent.DANGER}
                onClick={() => setIsForceDeleteAlertOpen(true)}
              />
            </Menu>
          }
        >
          <Button icon={IconNames.MORE} css={styles.headerButton} loading={forceDeleting} />
        </Popover>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Button text="Bearbeiten" icon={IconNames.EDIT} css={styles.headerButton} onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteEmployee as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} css={styles.headerButton} loading={deleting} />
      </Popover>
    </Fragment>
  );
};

export default EmployeeDetailMenu;

const styles = {
  statusTag: css`
    margin-left: 10px;
  `,
  headerButton: css`
    margin-left: 10px;
  `,
};
